"use client"

import { Banner } from '@/app/components/Banner'
import ServiceContent from '@/app/components/ServiceContent'
import { seoImg } from '@/assets/imgs'
import { useTranslations } from 'next-intl'


const SearchEngineOptimization = () => {
  const  t  = useTranslations()
  return (
    <>
      <Banner
        subUrl={t('links.services')}
        name={t('links.seo')}
        description={t('seo.bannerDescription')}
        className='bg-seoBanner'
      />
      <ServiceContent
        title={t('links.seo')}
        header={t('seo.header')}
        subContent={t('seo.subTitle')}
        content={t('seo.content')}
        img={seoImg}
      />
    </>
  )
}

export default SearchEngineOptimization
